import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { useAppSelector } from "../../../services/hooks"
import './productSchema.scss'
import { InfoProductType } from "../../../stores/product/productSlice.types"

export default function ProductSchema({ setActivePart, data }: { setActivePart: any, data: InfoProductType['parts'] }) {
    const backgroundUrl = useAppSelector((state) => state.product.data.image.schema?.background.url)
    const width = useAppSelector((state) => state.product.data.image.schema?.background.width)
    const height = useAppSelector((state) => state.product.data.image.schema?.background.height)
    const points = useAppSelector((state) => state.product.data.image.schema?.points)

    if (!data || !backgroundUrl || !width || !height || !points) return

    const Title = ({ children, point }: any) => (
        <OverlayTrigger overlay={<Tooltip id={point.id.toString()}><span style={{ color: "" }}>{(data.find((part) => part.schemaId == point.id)?.name)}</span></Tooltip>}>
            <a href={`#${point.id}`} onClick={() => setActivePart(point.id)}>{children}</a>
        </OverlayTrigger>
    )

    const showPoints = points?.map((point) => {
        return <Title point={point}><circle className="interactive-circle" cx={point.cx} cy={point.cy} r={point.r} /></Title>
    })

    return (
        <>
            <svg viewBox={`0, 0, ${width}, ${height}`}>
                <image href={backgroundUrl} />
                {showPoints}
            </svg>
        </>
    )
}